var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa",
    x1: 60.251,
    y1: 13.693,
    x2: 65.995,
    y2: 13.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa",
    y1: 27.323,
    y2: 27.323,
    xlinkHref: "#SVGID_0_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa",
    y1: 40.954,
    y2: 40.954,
    xlinkHref: "#SVGID_0_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa",
    x1: 24.954,
    y1: 57.449,
    x2: 61.501,
    y2: 57.449,
    xlinkHref: "#SVGID_0_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa",
    x1: 31.969,
    y1: 22.35,
    x2: 50.374,
    y2: 22.35,
    xlinkHref: "#SVGID_0_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa",
    x1: 40.604,
    y1: 24.313,
    x2: 42.325,
    y2: 24.313,
    xlinkHref: "#SVGID_0_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa",
    x1: 38.951,
    y1: 20.93,
    x2: 42.325,
    y2: 20.93,
    gradientTransform: "rotate(90 40.638 20.93)",
    xlinkHref: "#SVGID_0_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa",
    x1: 40.568,
    y1: 18.273,
    x2: 42.453,
    y2: 18.273,
    xlinkHref: "#SVGID_0_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.876 8.719h4.494v7.995a1.953 1.953 0 01-1.952 1.952h-2.542V8.719h0z",
    stroke: "url(#SVGID_0_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa)",
    fill: "none",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.876 22.35h4.494v7.995a1.953 1.953 0 01-1.952 1.952h-2.542V22.35h0z",
    stroke: "url(#SVGID_1_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa)",
    fill: "none",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.876 35.981h4.494v7.995a1.953 1.953 0 01-1.952 1.952h-2.542v-9.947h0z",
    stroke: "url(#SVGID_2_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa)",
    fill: "none",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SVGID_3_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa)",
    fill: "none",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M25.579 57.449h35.297"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M60.876 54.323V5.419H19.63l.029 51.758"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M60.876 54.322H22.788a3.138 3.138 0 00-3.129 3.129 3.138 3.138 0 003.129 3.129h38.088v-6.258z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.172,
    cy: 22.35,
    r: 8.578,
    stroke: "url(#SVGID_4_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa)",
    fill: "none",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa)",
    d: "M40.604 20.829h1.721v6.969h-1.721z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.64 19.243c.301 0 .546.245.546.546v2.665c0 .09-.073.163-.163.163h-.769a.163.163 0 01-.163-.163v-2.662a.55.55 0 01.549-.549z",
    transform: "rotate(-90 40.638 20.93)",
    fill: "url(#SVGID_6_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.511,
    cy: 18.273,
    r: 0.942,
    fill: "url(#SVGID_7_fcb0a4cbc7e65d4e31933881b35ee24aef2f4905ef18b44e355f0c5185c52cfa)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.980a9709b08ae9171930da1f72e056a8.svg";
export { ForwardRef as ReactComponent };